import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { kubernetesLiveUsageMgmtAppliedFiltersByResourceTypeSelector } from "@/store/kubernetes-live-usage-mgmt/selectors/filters/kubernetesLiveUsageMgmtAppliedFiltersByResourceTypeSelector";
import { kubernetesLiveUsageMgmtResourceViewIsWithoutFiltersSelector } from "@/store/kubernetes-live-usage-mgmt/selectors/resource-type-data/kubernetesLiveUsageMgmtResourceViewIsWithoutFiltersSelector";
import { kubernetesLiveUsageMgmtFilterTemplatesEnabledSelector } from "@/store/kubernetes-live-usage-mgmt/selectors/filters/kubernetesLiveUsageMgmtFilterTemplatesEnabledSelector";

export const kubernetesLiveUsageMgmtAppliedFiltersWithRegionsByResourceTypeSelector =
  createDraftSafeSelector(
    [
      kubernetesLiveUsageMgmtAppliedFiltersByResourceTypeSelector,
      kubernetesLiveUsageMgmtResourceViewIsWithoutFiltersSelector,
      kubernetesLiveUsageMgmtFilterTemplatesEnabledSelector,
    ],
    (filters, showingAllResources, filterTemplatesEnabled) => {
      if (showingAllResources || !filterTemplatesEnabled || !filters) {
        return null;
      }

      return filters;
    },
  );
